<ion-header no-border>
  <app-close-button (onClicked)="cancel()" [isModal]="true"></app-close-button>
</ion-header>

<ion-content>
  <div class="schedule-editor-layout">
    <!-- Left Panel: Schedule Controls -->
    <div class="editor-panel">
      <div class="page-title">{{ 'WORK_SCHEDULE.Edit_Schedule' | translate }}</div>

      <!-- Multi-Location Mode Info Banner -->
      <div class="multi-location-banner" *ngIf="config.multiLocationMode">
        <ion-icon name="location-outline"></ion-icon>
        <span>{{ 'WORK_SCHEDULE.Multi_Location_Folder' | translate }}</span>
      </div>

      <!-- Multi-Location Schedule Editor (for folders spanning multiple locations) -->
      <div *ngIf="config.multiLocationMode && config.locations?.length > 1">
        <app-multi-location-schedule-editor
          [locations]="config.locations"
          [config]="multiLocationConfig"
          [inheritedWorkDaysScheduleID]="config.inheritedWorkDaysScheduleID"
          [inheritedWorkDaysName]="config.inheritedWorkDaysName"
          [inheritedDaysOffScheduleID]="config.inheritedDaysOffScheduleID"
          [inheritedDaysOffName]="config.inheritedDaysOffName"
          [effectiveWorkDaysScheduleID]="config.effectiveWorkDaysScheduleID"
          [effectiveDaysOffScheduleID]="config.effectiveDaysOffScheduleID"
          [subjectType]="config.subjectType"
          [subjectID]="config.subjectID"
          (configChanged)="onMultiLocationConfigChange($event)">
        </app-multi-location-schedule-editor>
      </div>

      <!-- Single Schedule Selection Section (default for single-location folders) -->
      <div class="schedule-selection-section" *ngIf="!config.multiLocationMode || config.locations?.length <= 1">
        <h3>{{ 'WORK_SCHEDULE.Schedule_Selection' | translate }}</h3>
        <p class="section-hint">{{ 'WORK_SCHEDULE.Schedule_Selection_Hint' | translate }}</p>

        <div class="schedule-pickers">
          <div class="picker-field">
            <ion-label>{{ 'WORK_SCHEDULE.Work_Days' | translate }}</ion-label>
            <ion-select
              [(ngModel)]="workDaysScheduleID"
              (ionChange)="onWorkDaysChange()"
              interface="popover"
              [placeholder]="'WORK_SCHEDULE.Select_Schedule' | translate">
              <ion-select-option *ngFor="let schedule of workDaysScheduleOptions" [value]="schedule.scheduleID">
                {{ schedule.name }}
              </ion-select-option>
            </ion-select>
          </div>

          <div class="picker-field">
            <ion-label>{{ 'WORK_SCHEDULE.Days_Off' | translate }}</ion-label>
            <ion-select
              [(ngModel)]="daysOffScheduleID"
              (ionChange)="onDaysOffChange()"
              interface="popover"
              [placeholder]="'WORK_SCHEDULE.Select_Schedule' | translate">
              <ion-select-option *ngFor="let schedule of daysOffScheduleOptions" [value]="schedule.scheduleID">
                {{ schedule.name }}
              </ion-select-option>
            </ion-select>
          </div>
        </div>
      </div>

      <!-- Entries Section -->
      <div class="entries-section" *ngIf="config.subjectID > 0">
        <h3>{{ 'WORK_SCHEDULE.Subject_Specific_Entries' | translate: { subject: subjectTypeLabel } }}</h3>

        <div class="immediate-save-warning">
          <ion-icon name="warning-outline"></ion-icon>
          <span>{{ 'WORK_SCHEDULE.Entries_Save_Immediately' | translate }}</span>
        </div>

        <!-- Work Days Entries Editor -->
        <app-schedule-entries-editor
          [subjectType]="config.subjectType"
          [subjectID]="config.subjectID"
          [scheduleID]="effectiveWorkDaysScheduleID"
          [scheduleType]="WorkScheduleType.Work_Days"
          [sectionLabel]="'WORK_SCHEDULE.Work_Days_Entries' | translate"
          [hintText]="'WORK_SCHEDULE.Work_Days_Entries_Hint' | translate">
        </app-schedule-entries-editor>

        <!-- Days Off Entries Editor -->
        <app-schedule-entries-editor
          [subjectType]="config.subjectType"
          [subjectID]="config.subjectID"
          [scheduleID]="effectiveDaysOffScheduleID"
          [scheduleType]="WorkScheduleType.Days_Off"
          [sectionLabel]="'WORK_SCHEDULE.Days_Off_Entries' | translate"
          [hintText]="'WORK_SCHEDULE.Days_Off_Entries_Hint' | translate">
        </app-schedule-entries-editor>
      </div>

      <!-- No subject ID message for new items -->
      <div class="no-subject-message" *ngIf="config.subjectID <= 0">
        <ion-icon name="information-circle-outline"></ion-icon>
        <p>{{ 'WORK_SCHEDULE.Save_First_For_Entries' | translate: { subject: subjectTypeLabel } }}</p>
      </div>
    </div>

    <!-- Right Panel: Calendar Preview -->
    <div class="preview-panel">
      <div class="preview-header">
        <h3>{{ 'WORK_SCHEDULE.Calendar_Preview' | translate }}</h3>
      </div>
      <div class="preview-calendar">
        <app-schedule-calendar
          [workDaysScheduleID]="effectiveWorkDaysScheduleID"
          [daysOffScheduleID]="effectiveDaysOffScheduleID"
          [subjectType]="config.subjectType"
          [subjectID]="config.subjectID"
          [showLegend]="true"
          [readonly]="true">
        </app-schedule-calendar>
      </div>
    </div>
  </div>

  <!-- Footer buttons matching FormBuilder pattern -->
  <div class="changes-panel">
    <div class="ui-form-controls">
      <a class="ui-btn button-styled" (click)="save()" [class.disabled]="!hasChanges">
        {{ 'SHARED.Save_Changes' | translate }}
      </a>
      <a class="ui-btn button-styled bg-neutral" (click)="cancel()">
        {{ 'SHARED.Cancel' | translate }}
      </a>
    </div>
  </div>
</ion-content>
